import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { ClassAttributes, createElement } from 'react';

import { File as UploadedFile } from '../../../../../graphql/generated/graphql';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../../styleUtility/flexibleLayout';
import FileSize from '../../../primitive/FileSize';
import _ImageScreen from '../../../primitive/ImageScreen';
import _FileUploader from '../../FileUploader';
import AttachmentUploaderProcessing from './AttachmentUploaderProcessing';

interface Props {
  uploadAttachment: (file: File | null) => void;
  uploadingAttachment: boolean;
  uploadedAttachment: UploadedFile | null;
  className?: string;
}

const AttachmentUploader = ({
  uploadAttachment,
  uploadingAttachment,
  uploadedAttachment,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  let content = null;

  if (uploadingAttachment) {
    content = <AttachmentUploaderProcessing />;
  } else if (uploadedAttachment?.url) {
    content = (
      <Attachment>
        <ImageScreen src={uploadedAttachment.url} />

        <FileData>
          <Typography variant="caption">{uploadedAttachment.originalFileName}</Typography>
          <FileSize fileSize={uploadedAttachment.size}>
            {(fileSize) => <Typography variant="caption">{fileSize}</Typography>}
          </FileSize>
        </FileData>

        <CancelButton onClick={() => uploadAttachment(null)}>
          <CancelIcon />
        </CancelButton>
      </Attachment>
    );
  } else {
    content = <FileUploader onRequestFileUpload={(files: FileList) => uploadAttachment(files[0])} />;
  }

  return <Root className={className}>{content}</Root>;
};

const Root = styled('div')({ width: '100%' });

const Attachment = styled('div')(
  flexibleLayoutContainer({
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  { padding: SPACING_UNIT, border: '1px solid #eee', borderRadius: 8 },
);

const ImageScreen = styled(_ImageScreen)({
  marginRight: SPACING_UNIT,
  maxWidth: 200,
  height: 64,
});

const CancelButton = styled('div')({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  marginLeft: SPACING_REGULAR,
  cursor: 'pointer',
});

const CancelIcon = styled(Close)({
  width: 24,
  height: 24,
});

const FileUploader = styled(_FileUploader)({
  flexDirection: 'row',
  padding: `${SPACING_UNIT / 2}px ${SPACING_UNIT * 3}px`,
  '> *': {
    margin: `${SPACING_UNIT * 2}px ${SPACING_UNIT}px`,
  },
});

const FileData = styled('div')({
  flex: 1,
  wordBreak: 'break-word',
  padding: '5px',
});

export default AttachmentUploader;
